/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DayCountConventionEnum,
    DayCountConventionEnumFromJSON,
    DayCountConventionEnumFromJSONTyped,
    DayCountConventionEnumToJSON,
} from './DayCountConventionEnum';

/**
 * 
 * @export
 * @interface SavingsAccountHistoryMetaDataDto
 */
export interface SavingsAccountHistoryMetaDataDto {
    /**
     * 
     * @type {DayCountConventionEnum}
     * @memberof SavingsAccountHistoryMetaDataDto
     */
    dayCountConvention: DayCountConventionEnum | null;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountHistoryMetaDataDto
     */
    interestRate: number;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountHistoryMetaDataDto
     */
    taxRate?: number;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountHistoryMetaDataDto
     */
    interestBeforeTax?: number;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountHistoryMetaDataDto
     */
    interest?: number;
    /**
     * 
     * @type {number}
     * @memberof SavingsAccountHistoryMetaDataDto
     */
    tax?: number;
}

export function SavingsAccountHistoryMetaDataDtoFromJSON(json: any): SavingsAccountHistoryMetaDataDto {
    return SavingsAccountHistoryMetaDataDtoFromJSONTyped(json, false);
}

export function SavingsAccountHistoryMetaDataDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SavingsAccountHistoryMetaDataDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dayCountConvention': DayCountConventionEnumFromJSON(json['dayCountConvention']),
        'interestRate': json['interestRate'],
        'taxRate': !exists(json, 'taxRate') ? undefined : json['taxRate'],
        'interestBeforeTax': !exists(json, 'interestBeforeTax') ? undefined : json['interestBeforeTax'],
        'interest': !exists(json, 'interest') ? undefined : json['interest'],
        'tax': !exists(json, 'tax') ? undefined : json['tax'],
    };
}

export function SavingsAccountHistoryMetaDataDtoToJSON(value?: SavingsAccountHistoryMetaDataDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'dayCountConvention': DayCountConventionEnumToJSON(value.dayCountConvention),
        'interestRate': value.interestRate,
        'taxRate': value.taxRate,
        'interestBeforeTax': value.interestBeforeTax,
        'interest': value.interest,
        'tax': value.tax,
    };
}

